<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="filters-container flex flex-wrap items-center justify-start">
          <div class="form-group has-search ml-3 position-relative">
            <span class="fa fa-search form-control-company-feedback"></span>
            <input
              @input="SearchUser()"
              id="quickFilter"
              v-model="search_user_name"
              class="filter_input_company form-control-company"

            >
          </div>
          <active-only
            class=" ml-3"
            @toggle="SearchWithField($event, 'status')"
          />
        </div>

        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
          <vs-button
            class="mt-3 mx-1"
            @click="$router.push({ name: 'Company_admin_DIDs_ByDid' })"
          >Buy Did</vs-button>
          <div class="buttons-container">
            <vue-excel-xlsx
              style="display: none"
              ref="exportBtn"
              :data="export_data"
              :columns="data_fields"
              :filename="ExcelFileName"
              sheetname="Usage Report"
            >
            </vue-excel-xlsx>
            <vs-button
              class="mt-3"
              @click="ExportExcel"
            >Download</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <!-- Per Page -->
<!--      <div class="mb-4 md:mb-0">-->
<!--        <per-page-->
<!--          :currentPerPage="per_page"-->
<!--          :pageStart="pageStart"-->
<!--          :pageEnd="pageEnd"-->
<!--          :total="total"-->
<!--          @change-per-page="ChangePerPage($event)"-->
<!--        />-->
<!--      </div>-->

      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        :class="{'noDataTable': !list.length}"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"

        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
import TableMixin from '@/mixins/table.js'
import { AgGridVue } from 'ag-grid-vue'
import CellRendererActions from "./cell-renderer/CellRendererActions";
import CellRendererStatus from "../../admin/clients/companies/cell-renderer/CellRendererStatus";
import {format} from "date-fns";

export default {
  mixins: [TableMixin],
  components: {
    AgGridVue,
    CellRendererActions
  },
  data() {
    return {
      // table header value
      gridOptions: {},
      search_user_name:'',
      columnDefs: [
        {
          headerName: 'DID',
          field: 'did',
          minWidth: 220,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: 'Created On',
          field: 'created_on',
          minWidth: 220
        },
        {
          headerName: 'Country',
          field: 'countryName',
          minWidth: 220
        },
        /*{
          headerName: 'MRC',
          field: 'mrc',
          minWidth: 220
        },
        {
          headerName: 'NRC',
          field: 'nrc',
          minWidth: 220
        },
        {
          headerName: 'State',
          field: 'state',
          minWidth: 220
        },
        {
          headerName: 'Lata',
          field: 'lata',
          minWidth: 220
        },
        {
          headerName: 'Type',
          field: 'type',
          minWidth: 220
        },*/
        {
          headerName: 'Action',
          flex: 0,
          cellRendererFramework: 'CellRendererActions',
          minWidth: 100,
        },

      ],
      list: [],
      listTotal:[],
      export_data: [],
      data_fields: [],

      // Cell Renderer components
      components: {
        CellRendererActions,
        // CellRendererStatus
      },
      searchProduct: ''
    }
  },
  computed:{
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    currentPage:{
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
      ExcelFileName() {
        return `usage_report_${format(new Date(), 'yyyy_MM_dd')}`
      }

    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
  },
  methods: {
    async ExportExcel() {
      this.$vs.loading()
      const params = {
        ...this.filters,
        page: this.page || 0,
        per_page: this.per_page || 10,
        order_by: this.order_by || 'created_on',
        order_dir: this.order_dir || 'desc',
        // fields: 'tx_cost,sent,delivered'
      }
      console.log("<--------------------------------Data")
      const { total } = await this.$store.dispatch("didcompany/GetList", params)
      console.log(total,"<--------------------------------Data")
      this.$vs.loading.close()
      const { data } = await this.$store.dispatch("didcompany/GetList", params)
console.log(!data.length,"<--------------------------------Data")
      if (!data.length) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Download fail',
          text: 'Data not found',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      this.$vs.loading.close()

      this.export_data = data.map(this.TransformList)
       console.log(this.export_data,"<----------------------------export_data")
      this.data_fields = [
        { label: 'Date', field: 'sms_time' },
        { label: 'Total', field: 'sent' },
        { label: 'Success', field: 'delivered' },
        { label: 'Cost', field: 'tx_cost' }
      ]

      const is_exist_client = data[0].hasOwnProperty('Created On')
      const is_exist_vendor = data[0].hasOwnProperty('Country')

      if (is_exist_client) {
        this.data_fields = [
          ...this.data_fields,
          { label: 'Created On', field: 'created_on' }
        ]
      }
      if (is_exist_vendor) {
        this.data_fields = [
          ...this.data_fields,
          { label: 'Country', field: 'countryName' }
        ]
      }

      setTimeout(() => {
        this.$refs.exportBtn.$el.click()
        this.$vs.loading.close()
      }, 1000);

    },
    GetList () {
      this.$vs.loading()
      this.$store.dispatch('didcompany/GetList', {
        ...this.filters,
        page: this.page || 0,
        per_page: this.per_page || 10,
        order_by: this.order_by || 'created_on',
        order_dir: this.order_dir || 'desc',
      })
        .then(res => {
          this.listTotal= res.items
          this.list = res.items.map(this.TransformList)
          this.total = res.total
        })
        .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
        .finally(() => this.$vs.loading.close())
    },
    SearchUser(){
      this.GetList()
    },
    SearchWithField (e, field) {
      if (!e) delete this.filters[field]
      else this.filters[field] = e && e.value

      // this.GetList()
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },

    // Transform functions
    TransformList(item) {
      console.log(item)
      return {
        refreshData: this.GetList,
        country: item.area.country.name,
        created_on: item.created_on,
        did: item.did,
        countryName:'USA',
        mrc: item.mrc,
        state: item.state,
        lata: item.lata,
        status:item.status,
        on_net: item.on_net,
        type:item.type,
        number: item.using.did_number
      }
    },
    TransformUsageReport(item) {
      console.log(item)
      return {
        ...item,
        sms_time: format(new Date(item.sms_time * 1000), "yyyy:MM:dd HH:mm:ss"),
      };
    },
 /*   download(table, name) {
      if (!table.nodeType) table = this.$refs.table;
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };

      const link = document.createElement("a");
      link.href = this.uri + this.base64(this.format(this.template, ctx));
      link.setAttribute("download", "dids.xls");
      link.click();
    },*/
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridApi.sizeColumnsToFit()
  },
  created(){
    this.GetList()
  },
}
</script>

<style scoped>
  .filter_input_company{
    padding: 17px;
    padding-left: 55px;
    width: 220px;
    height: 41px;
    border: 1px solid #f5f5f5;
    font-size: 13px;
    color: gray;
    background-repeat: no-repeat;
    background-position: left center;
    outline: 0;
  }
  .has-search .form-control-company-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 15px;
    height: 15px;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: gray;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
  }
</style>
<style scoped lang="scss">
  .did-container {
    padding: 0;
    margin-top: 20px;
    .content {
      height: fit-content;
      .nav-header {
        height: 50px;
        background-color: #fff;
        padding: 0px 15px 0px 15px;
        display: flex;
        p {
          cursor: pointer;
          height: 100%;
          display: flex;
          align-items: center;
          padding: 0px 5px 0px 5px;
          color: #bdbfd8;
          font-family: ""Helvetica Neue"";
          font-size: 16px;
          font-weight: 500;
          line-height: 20px;
          text-align: center;
          margin-right: 10px;
          margin-bottom: 0;
        }
        .active {
          color: #51a3f3;
          border-bottom: 2px solid #51a3f3;
        }
      }
    }

    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      margin-top: 20px;
      .secondary-but.ton {
        height: 40px;
        width: 90px;
        margin-right: 15px;
      }
    }
  }
</style>
